import { render, staticRenderFns } from "./logistics.vue?vue&type=template&id=77fd169b&scoped=true"
import script from "./logistics.vue?vue&type=script&lang=ts"
export * from "./logistics.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77fd169b",
  null
  
)

export default component.exports